<template>
  <div>
    <div
      class="disabledCss"
      v-if="(type === 'see' || item.code === 'CreatedDept') && !item.type"
    >
      <span v-for="op in formData[item.code]" :key="op.id">
        {{ op.name }}
      </span>
    </div>
    <div
      style="
        text-align: center;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        border-radius: 4px;
        height: 34px;
      "
      @click="handleOpenPicker"
      v-else
    >
      <div
        style="height: 100%; padding: 0 9px 0 15px"
        v-show="!formData[item.code] || formData[item.code].length < 1"
      >
        <div
          class="between"
          v-show="!formData[item.code] || formData[item.code].length < 1"
          @click="$refs.orgPicker.show()"
          style="color: #c0c4cc"
        >
          <span style="color: #86909c; line-height: 32px">选择部门</span>
          <i class="el-icon-arrow-down"></i>
        </div>
        <org-picker
          type="dept"
          :multiple="
            item.name === 'MultipleDeptPicker' || (item.type && item.type === 2)
          "
          ref="orgPicker"
          :selected="formData[item.code] || []"
          @ok="selected"
          :disabled="disabled"
        />
        <!-- <span class="placeholder"> 请选择部门 </span> -->
      </div>
      <div style="display: flex; flex-wrap: wrap">
        <el-tag
          size="mini"
          style="margin: 5px"
          closable
          v-for="(dept, i) in formData[item.code]"
          @close="delDept(i)"
          :key="i"
          >{{ dept.name }}</el-tag
        >
      </div>
    </div>
  </div>
</template>

<script>
import OrgPicker from "@/components/common/OrgPicker";
import Minxins from "../Minxins";
export default {
  name: "DeptPicker",
  components: { OrgPicker },
  mixins: [Minxins],
  data() {
    return {
      showOrgSelect: false,
    };
  },
  methods: {
    handleOpenPicker() {
      if (this.disabled) return;
      this.$refs.orgPicker.show();
    },
    selected(values) {
      this.showOrgSelect = false;
      this.formData[this.item.code] = values;
      this.$emit("queryList");
    },
    delDept(i) {
      this.formData[this.item.code].splice(i, 1);
      this.$emit("queryList");
    },
  },
};
</script>

<style scoped lang="less" >
.disabledCss {
  padding: 0 !important;
  span {
    margin: 4px 4px;
    height: 20px;
    line-height: 20px;
    cursor: pointer;
    border: 1px solid #e9e9eb;
    padding: 5px;
    border-radius: 5px;
    color: #304265;
    white-space: normal;
  }
}
</style>
